// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3_IDu","itemTitle":"ClientEmergencyInfo_itemTitle__2AwOK","itemText":"ClientEmergencyInfo_itemText__3n26z"};